import { AssetType } from '../../constant/assetConstants';
import { HeartOutlined, ShoppingCartOutlined } from '@ant-design/icons';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useSessionContext } from 'src/context/session-context';
import MyFavoriteModal from '../modal/myFavoriteModal';
import { RecommendAssetItemModel } from 'src/models/BannerModel';
import AddToCartModal from '../modal/addToCartModal';
import TranslationKey from 'src/i18n/translation';

interface RecommentItemInterface {
    sliderId: string,
    recommentAssetItemIndex: number;
    recommentAssetItem: RecommendAssetItemModel;
}

export default function RecommendItem(
    {
        sliderId,
        recommentAssetItem,
        recommentAssetItemIndex,
    }: RecommentItemInterface) {
    const navigate = useNavigate();
    const { userProfile } = useSessionContext();
    const [isOpenFavorite, setIsOpenFavorite] = useState(false);
    const [isOpenAddToCart, setIsOpenAddToCart] = useState(false);

    const onClickItem = (assetId: string) => {
        window.location.href = '/asset/' + assetId;
    };

    const onClickFavorite = () => {
        if (userProfile && userProfile.userId) {
            setIsOpenFavorite(true);

            return;
        }

        message.open({
            type: 'error',
            content: TranslationKey('loginToUseThisFeature'),
        });
    };

    const handleCloseFav = () => {
        setIsOpenFavorite(false);
    };

    const onClickToArtist = (userId: string) => {
        navigate(`/artist/${userId}`)
    };

    const addToCard = () => {
        setIsOpenAddToCart(true);
    }

    return (
        <>
            <div className="containerImage">
                <div className='slider' key={`slider-main-${sliderId}${recommentAssetItemIndex}`}>
                    <div className='slider' key={`slider-main-item-${sliderId}${recommentAssetItemIndex}`}
                        onClick={() => onClickItem(recommentAssetItem.asset.id)}>
                        <img
                            key={`slider-main-item-image-${sliderId}${recommentAssetItemIndex}`}
                            src={
                                recommentAssetItem.asset.assetType === AssetType.VIDEO
                                    ? recommentAssetItem.asset.thumbnailVideoCoverUrl
                                    : recommentAssetItem.asset.thumbnailImageUrl
                            }
                            className='gallery-img'
                            alt={recommentAssetItem.asset.name}
                        />
                        <div className='overlay'></div>
                    </div>
                </div>
                <HeartOutlined size={30} className='favorite-rec' onClick={() => onClickFavorite()} />
                <ShoppingCartOutlined size={30} className='fa-download-rec' onClick={() => addToCard()} />
                <div
                    className='artist-rec'
                    onClick={() => onClickToArtist(recommentAssetItem.asset.userId)}>
                    {
                        recommentAssetItem.asset &&
                        recommentAssetItem.asset.artistFirstname + ' ' + recommentAssetItem.asset.artistLastname
                    }
                </div>

                <MyFavoriteModal
                    isFavoriteModalOpen={isOpenFavorite}
                    assetId={recommentAssetItem.asset.id!}
                    onCloseFavoriteModal={handleCloseFav} />

                <AddToCartModal
                    isModalOpen={isOpenAddToCart}
                    onCloseModal={() => setIsOpenAddToCart(false)}
                    assetId={recommentAssetItem.assetId} />
            </div>
        </>
    );
}